import { Link } from "react-router-dom";
import { mediaUrl } from "../../lib/api";

const BADGE = {
  Available: "bg-success/10 text-success border-success",
  "On trial": "bg-amber-soft text-amber-ink border-amber-ink",
  "Coming soon": "bg-teal-soft text-teal border-teal",
};

export function AvailabilityBadge({ value }) {
  return (
    <span className={`inline-flex items-center rounded-full border px-3 py-1 text-sm font-semibold ${BADGE[value] || BADGE.Available}`} data-testid="availability-badge">
      <span className="sr-only">Trial availability: </span>{value}
    </span>
  );
}

export default function ProductCard({ p }) {
  return (
    <article className="card group flex flex-col overflow-hidden transition-shadow hover:shadow-lg" data-testid={`product-card-${p.slug}`}>
      <div className="relative aspect-[4/3] overflow-hidden bg-sand">
        {p.images?.[0] && <img src={mediaUrl(p.images[0])} alt={p.image_alts?.[0] || ""} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />}
        {p.is_sample && <span className="absolute left-3 top-3 rounded-full bg-surface px-3 py-1 text-xs font-bold uppercase tracking-wide text-ink">Sample data</span>}
      </div>
      <div className="flex flex-1 flex-col p-6">
        <p className="text-sm font-semibold text-amber-ink">{p.category}</p>
        <h3 className="mt-1 font-display text-xl font-semibold">
          <Link to={`/equipment/${p.slug}`} className="hover:text-teal hover:underline" data-testid={`product-link-${p.slug}`}>{p.name}</Link>
        </h3>
        <p className="mt-2 flex-1 text-ink-muted">{p.summary}</p>
        <div className="mt-4"><AvailabilityBadge value={p.availability} /></div>
        <div className="mt-5 flex flex-wrap gap-2">
          <Link to={`/request-trial?item=${encodeURIComponent(p.slug)}`} className="btn-primary flex-1 !px-4" aria-label={`Request a trial of ${p.name}`} data-testid={`product-trial-btn-${p.slug}`}>Request a Trial</Link>
          <Link to={`/equipment/${p.slug}`} className="btn-outline !px-4" aria-label={`View details for ${p.name}`}>Details</Link>
        </div>
      </div>
    </article>
  );
}
